import { useMutation, useQuery } from "react-query";
import { AdminNewsletterAccountService } from "../../../services/newsletter/adminNewsletterAccount.service";
import { NewsletterAccountService } from "../../../services/newsletter/newsletterAccount.service";
export var useNewsletterAccountQuery = function () {
    return useQuery('currentNewsletterAccount', function () {
        return NewsletterAccountService.getNewsletterAccountInfo();
    });
};
// As administrator has access to all newsletter accounts -> we need to specify the orgId
export var useAdminNewsletterAccountQuery = function (organizationId) {
    return useQuery(['adminNewsletterAccount', organizationId], function () { return AdminNewsletterAccountService.getNewsletterAccount({
        organizationId: organizationId
    }); }, {
        enabled: !!organizationId
    });
};
export var useCreateNewsletterAccountMutation = function () {
    return useMutation(function (payload) {
        return AdminNewsletterAccountService.createNewsletterAccount(payload);
    });
};
